
export enum PriceType {
  PricePerService = 'PricePerService',
  PricePerGram = 'PricePerGram',
  PricePerCm = 'PricePerCm',
  PricePerMinute = 'PricePerMinute',
  PricePerFinger = 'PricePerFinger',
  PricePerHour = 'PricePerHour',
  PricePerHourPerPerson = 'PricePerHourPerPerson',
  PricePerLiter = 'PricePerLiter',
  PricePerDeciliter = 'PricePerDeciliter',
  PricePerHeadlight = 'PricePerHeadlight',
}
